// 需要 jquery   slick
if (!customElements.get("five-collection-listing")) {
    customElements.define(
      "five-collection-listing",
      class ScrollShopPoint extends HTMLElement {
        constructor(){
          super();
          this.five_collection_listing = $(this).find('.five-collection-listing-mobile');
          this.initScrollShopPoint();
        }

        initScrollShopPoint(){
          const that = this;
          setTimeout(function(){
            that.five_collection_listing.slick({
              slidesToShow: 5,
              slidesToScroll: 1,
              autoplay: false,
              arrows: false,
              rows:0,
              responsive:[
                {
                  breakpoint: 768,
                  settings: {
                    autoplay: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: true
                  }
                }
              ]
            }).on('setPosition', function (event, slick) {
                slick.$slides.css('height', slick.$slideTrack.height() + 'px');
            });
          },0)
        }
      }
    )
}